import React from "react";
import Container from "../ui/Container";

export default function ProductSection({
  id,
  band = false,
  className = "",
  containerClassName = "",
  children,
}) {
  return (
    <section
      id={id}
      className={[
        "relative scroll-mt-28 py-16 md:py-24",
        band ? "bg-bg1" : "bg-bg0",
        className,
      ].join(" ")}
    >
      <Container className={containerClassName}>{children}</Container>
    </section>
  );
}
